import MarkerText from './MarkerText'

type NoteTooltipContentProps = {
  text: string
}

const NoteTooltipContent = ({ text }: NoteTooltipContentProps) => (
  <div className='max-w-72 flex items-center gap-0.5 flex-wrap justify-center'>
    <MarkerText text={text} />
  </div>
)

export default NoteTooltipContent
